import type { Store } from '../../types';

export const getVerifyPolicyInput = (state: Store) => state.verifyPolicy.input;
export const getVerifyPolicyFlow = (state: Store) => state.verifyPolicy.flow;
export const getVerifyPolicyCovie = (state: Store) => state.verifyPolicy.covie;
export const getVerifyPolicyComplianceProvider = (state: Store) =>
  state.verifyPolicy.complianceProvider;
export const getVerifyPolicyAdditionalData = (state: Store) =>
  state.verifyPolicy.additionalData;
